module.exports = __webpack_public_path__ + "img/left pag.9c07edb7.svg";